export const privacyNoticeDefaultContent = `
<p>This notice describes how medical information about you may be used and disclosed and how you can get access to this information. Please review it carefully.</p>
<p>Your protected health information (i.e. individually identifiable information, such as names, dates, phone/fax numbers, email addresses, home addresses, social security numbers and demographic data) may be used or disclosed by us in one or more of the following respects:</p>
<ul>
  <li>To other health care providers (i.e., your general dentist, oral surgeon, etc.) in connection with our rendering orthodontic treatment to you (i.e., to determine the results of cleanings, surgery, etc.);</li>
  <li>To third party payors or spouses (i.e., insurance companies, employers with direct reimbursement, administrators of flexible spending accounts, etc.) in order to obtain payment of your account (i.e., to determine benefits, dates of payment, etc.)</li>
  <li>To certifying, licensing and accrediting bodies (i.e., The American Board of Orthodontics, state dental boards, etc.) in connection with obtaining certification, licensure or accreditation;</li>
  <li>Internally, to all staff members who have any role in your treatment;</li>
  <li>To other patients and third parties who may see or overhear incidental disclosures about your treatment alternatives or other health-related benefits and services that may be of interest to you.</li>
</ul>

<p>Any other uses or disclosures of your protected health information will be made only after obtaining your written authorization, which you have the right to revoke:</p>
<p>Under the new privacy rules, you have the right to:</p>

<ul>
  <li>Request restrictions on the use and disclosure of your protected health information;</li>
  <li>Requested confidential communication of your protected health information;</li>
  <li>Inspect and obtain copies of your protected health information through asking us;</li>
  <li>Amend or modify your protected health information in certain circumstances;</li>
  <li>Receive an accounting of certain disclosures made by us of your protected health information; and,</li>
  <li>You may, without risk of retaliation, file a complaint as to any violation by us of your privacy rights with us (by submitting inquiries to our Privacy Contact Person at our office address) or the United States Secretary of Health and Human Services (which must be filed within 180 days of the violation)</li>
</ul>

<p>We have the following duties under the privacy rules:</p>

<ul>
  <li>By law, to maintain the privacy of protected health information and to provide you with this notice setting forth our legal duties and privacy practices with respect to such information;</li>
  <li>To abide by the terms of our Privacy Notice that is currently in effect;</li>
  <li>To advise you of our right to change the terms of this Privacy Notice and to make the new notice provisions effective for all protected health information maintained by use, and that if we do so, we will provide you with a copy of the revised Privacy Notice.</li>
</ul>

<p>Please note that we are not obligated to:</p>

<ul>
  <li>Honor any request by you to restrict the use or disclosure of your protected health information;</li>
  <li>Amend your protected health information if, for example, it is inaccurate and incomplete: or;</li>
  <li>Provide an atmosphere that is free of the possibility that your protected health information may be incidentally overheard by other patients and third parties.</li>
</ul>

<p>This privacy notice is effective as of the date of your signature. If you have any questions about the information in this Notice, please ask for our Privacy Contact Person or direct your questions to the persons at our office. Thank you.</p>
`;

export const isRichTextEditorContentEmpty = (content) => {
  if (content === null || content === undefined) {
    return true;
  }

  const normalized = String(content).replace(/\u00a0/g, " ").trim();
  if (!normalized) {
    return true;
  }

  const textOnly = normalized
    .replace(/<p>(\s|&nbsp;|<br\s*\/?\s*>)*<\/p>/gi, "")
    .replace(/<div>(\s|&nbsp;|<br\s*\/?\s*>)*<\/div>/gi, "")
    .replace(/<br\s*\/?\s*>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]+>/g, "")
    .trim();

  return textOnly.length === 0;
};
